import React from 'react';
import PropTypes from 'prop-types';
import Link from 'react-router/lib/Link';
import { t } from '../../../../modules/infra/i18n';

const ImpersonateLink = ({ login, clicked }) => (
  <span>
    <Link className="u-type--bold u-co-primary" display-if={!clicked} to="#" onClick={login}>{t('admin:impersonate_user.link.login')}</Link>
    <span className="u-type--bold u-co-primary" display-if={clicked}>{t('admin:impersonate_user.link.logging_in')}</span>
  </span>
);

ImpersonateLink.propTypes = {
  login: PropTypes.func.isRequired,
  clicked: PropTypes.bool.isRequired,
};

export default ImpersonateLink;
